import {UserLevel} from '@netx/core-user/constants';

export const ATTRIBUTE_HISTROY_MINIMUM_LEVEL = UserLevel.PRODUCER;

export enum AttributeHistoryPref {
	ENABLED = 'metadata.history.enabled',
}
